document.addEventListener('DOMContentLoaded', function () {
  const modal = document.querySelector('[data-offer-popup]');
  if (!modal) return;

  const storageKey = modal.dataset.storageKey;
  const frequency = modal.dataset.frequency || 'session';
  const days = parseInt(modal.dataset.days, 10) || 7;
  const delay = (parseInt(modal.dataset.delay, 10) || 0) * 1000;
  const isDesignMode = modal.dataset.designMode === 'true';

  function isDismissed() {
    if (isDesignMode) return false;

    try {
      if (frequency === 'session') {
        return sessionStorage.getItem(storageKey) === '1';
      }

      const stored = localStorage.getItem(storageKey);
      if (!stored) return false;

      if (frequency === 'once') return true;

      if (frequency === 'days') {
        const parsed = JSON.parse(stored);
        const elapsed = Date.now() - parsed.dismissedAt;
        return elapsed < days * 24 * 60 * 60 * 1000;
      }
    } catch (error) {
      return false;
    }

    return false;
  }

  function markDismissed() {
    if (isDesignMode) return;

    try {
      if (frequency === 'session') {
        sessionStorage.setItem(storageKey, '1');
      } else {
        localStorage.setItem(storageKey, JSON.stringify({ dismissedAt: Date.now() }));
      }
    } catch (error) {
      // Storage may be unavailable in private browsing.
    }
  }

  function showPopup() {
    if (typeof modal.show === 'function') {
      modal.show();
    }
  }

  function bindDismissTracking() {
    // ModalDialog binds the close button to hide() in its constructor, before we
    // can patch hide(), so track dismiss on close directly as well.
    modal.querySelector('[id^="ModalClose-"]')?.addEventListener('click', markDismissed);

    if (typeof modal.hide === 'function') {
      const hideModal = modal.hide.bind(modal);
      modal.hide = function () {
        markDismissed();
        hideModal();
      };
    }

    modal.querySelector('.offer-popup__cta[href]')?.addEventListener('click', markDismissed);

    modal.querySelector('[data-offer-continue]')?.addEventListener('click', function () {
      if (typeof modal.hide === 'function') modal.hide();
    });
  }

  function bindCopyCoupon() {
    const copyButton = modal.querySelector('[data-offer-copy-coupon]');
    const couponCode = modal.querySelector('[data-offer-coupon-code]');
    const tooltip = copyButton?.querySelector('[data-offer-copy-tooltip]');

    if (!copyButton || !couponCode) return;

    copyButton.addEventListener('click', function () {
      const code = couponCode.textContent.trim();
      if (!code) return;

      navigator.clipboard.writeText(code).then(function () {
        if (!tooltip) return;

        tooltip.classList.add('is-visible');
        tooltip.setAttribute('aria-hidden', 'false');

        window.clearTimeout(copyButton._tooltipTimer);
        copyButton._tooltipTimer = window.setTimeout(function () {
          tooltip.classList.remove('is-visible');
          tooltip.setAttribute('aria-hidden', 'true');
        }, 2000);
      });
    });
  }

  bindDismissTracking();
  bindCopyCoupon();

  if (!isDismissed()) {
    window.setTimeout(showPopup, delay);
  }
});
